module.exports = __webpack_public_path__ + "fonts/sourcesanspro-semibold-webfont.50812c94.woff";